import UnderConstructionImg from "../../assets/under-contruction.png";

const UnderConstruction = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "80vh",
        overflow: "hidden",
      }}
    >
      <img
        src={UnderConstructionImg}
        alt="Under Construction"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // image fills while maintaining aspect ratio
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "80%",
          left: "20%",
          transform: "translate(-20%, -80%)",
          color: "white",
          fontSize: "3rem",
          fontWeight: "bold",
          textShadow: "2px 2px 10px rgba(0,0,0,0.6)",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        Coming soon!      </div>
    </div>
  );
};

export default UnderConstruction;
